import React from 'react';
import { Link } from 'react-router-dom';
import Pop from 'components/Popover/Pop';
import { PopNew } from 'components/Popover/PopNew';
import Text from 'components/Text/Text';
import classNames from 'classnames';
import style from './RestaurantsAsLinkList.module.scss';

interface IProps {
	restaurants: { id: string; restaurantName: Nullable<string> }[];
	isNewTooltip?: boolean;
	isNewPopover?: boolean;
}

export const RestaurantsAsLinkList: React.FC<IProps> = React.memo(
	({ restaurants, isNewTooltip = false, isNewPopover = false }) => {
		const contentClasses = classNames(style.container, { [style.newPopover]: isNewPopover });

		const RestaurantsContent = () => {
			return (
				<div className={contentClasses} data-test="RestaurantsContent">
					{restaurants.map((el) => (
						<div className={style.item} key={el.id}>
							<Link
								className={style.link}
								key={el.id}
								target={`blank_${Date.now()}`}
								rel="noopener noreferrer"
								to={`/clients/restaurants?restaurantFullInfoID=${el.id}`}>
								<Text
									className={style.name}
									translationKey={el.restaurantName}
									size="xs"
									withTooltip={true}
									isNewTooltip={isNewTooltip}
								/>
							</Link>
						</div>
					))}
				</div>
			);
		};

		const restaurantsCount = (
			<div className={style.wrapper}>
				<Text translationKey={String(restaurants.length)} data-test="numberOfRestaurants" />
			</div>
		);

		const renderPopover = () => {
			return isNewPopover ? (
				<PopNew content={<RestaurantsContent />} trigger="click">
					{restaurantsCount}
				</PopNew>
			) : (
				<Pop placement="bottomLeft" content={<RestaurantsContent />} trigger="click">
					{restaurantsCount}
				</Pop>
			);
		};

		return (
			<div data-test="RestaurantsAsLinkList">
				{restaurants.length > 0 ? renderPopover() : <Text translationKey="-" />}
			</div>
		);
	},
);
